import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Box,
  Stack,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import FileUpload from '../../common/inputs/FileUpload';

import useComplianceRequest from '../../../requests/ComplianceRequest';

const AppealRequestDialog = ({
  open,
  onClose,
  brandId,
  errorHandler,
  appealCategories,
}) => {
  const [loading, setLoading] = useState(false);
  const [appealEvidenceData, setAppealEvidenceData] = useState(null);
  const [appealCategory, setAppealCategory] = useState(null);
  const [explanation, setExplanation] = useState('');

  const {
    createAppeal,
    getAppealEvidence,
    uploadAppealEvidence,
    deleteAppealEvidence,
  } = useComplianceRequest();

  const handleUpload = async (event) => {
    const files = event.target.files;

    const evidence = await uploadAppealEvidence(
      brandId,
      files[0],
      errorHandler
    );
    console.log('evidence', evidence);

    fetchAppeals();
  };

  const handleDeleteEvidence = async (evidenceId) => {
    await deleteAppealEvidence(brandId, evidenceId, errorHandler);
    fetchAppeals();
  };

  useEffect(() => {
    fetchAppeals();
  }, []);

  async function fetchAppeals() {
    const evidence = await getAppealEvidence(brandId, errorHandler);
    console.log('evidence', evidence);
    setAppealEvidenceData(evidence);
  }

  const submitAppeal = async () => {
    const body = {
      appealCategories: [appealCategory],
      attachmentUuids: appealEvidenceData.map((evidence) => evidence.uuid),
      explanation: explanation,
    };

    const appeal = await createAppeal(brandId, body, errorHandler);
    console.log('appeal', appeal);
  };

  const generateEvidenceData = () => {
    if (!appealEvidenceData) {
      return <CircularProgress />;
    }

    return (
      <Table sx={{ marginY: 2 }}>
        <TableHead>
          <TableRow>
            <TableCell>File Name</TableCell>
            <TableCell align="right">Remove</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {appealEvidenceData.map((evidence) => (
            <TableRow key={evidence.evidence_id}>
              <TableCell>{evidence.fileName}</TableCell>
              <TableCell align="right">
                <IconButton
                  onClick={() => handleDeleteEvidence(evidence.uuid)}
                  color="error"
                  size="small"
                >
                  <Close />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Create new Appeal</DialogTitle>
      <DialogContent>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Appeal Category</InputLabel>
          <Select
            label="Appeal Category"
            value={appealCategory}
            onChange={(e) => setAppealCategory(e.target.value)}
          >
            {appealCategories.map((category) => (
              <MenuItem key={category.id} value={category.id}>
                {category.displayName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth sx={{ mt: 2 }}>
          <TextField
            label="Explanation"
            multiline
            rows={4}
            value={explanation}
            onChange={(e) => setExplanation(e.target.value)}
          />
        </FormControl>

        {generateEvidenceData()}

        <Stack direction="row" spacing={2} justifyContent="space-between">
          <Box sx={{ mt: 2 }}>
            <FileUpload
              label="Upload File"
              onChange={handleUpload}
              accept="application/pdf, image/*, document/*, text/*"
            />
          </Box>
          <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
            <Button onClick={onClose} variant="contained" color="secondary">
              Cancel
            </Button>
            <Button onClick={submitAppeal} variant="contained" color="primary">
              Create Appeal
            </Button>
          </Box>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default AppealRequestDialog;
